import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Col, Row, Form } from 'react-bootstrap';
import Web3 from 'web3';

import EXCHANGE from '../../ABI/ABI.json';
import SINGLE from '../../ABI/SINGLE.json';
import MULTIPLE from '../../ABI/MULTIPLE.json'
import Layout from '../../Layout/Layout';
import { BurnField, deleteStatus, gettokendata } from '../../actions/users';
import config from '../../lib/config'
import { toast } from 'react-toastify';

const initialFormValue = {
    
    "image" : "",
    "swapPrice" : 0,
    "tokenDesc" : "",
    "tokenPrice" : 0,
    "tokenCategory" : "",
    "likecount" : 0,
    "hashValue" : "",
    "status" : "",
    // "deleted" : 0,
    "tokenQuantity" : 0,
    "balance" : 0,
    "contractAddress" : "",
    "type" : 721,
    "minimumBid" : 0,
    "endclocktime" : null,
    "clocktime" : null,
    "unlockcontent" : "",
    "counts" : 0,
    "PutOnSale" : true,
    "PutOnSaleType" : "",
    "ipfsimage" : "",
    "tokenCounts" : 0,
    "tokenName" : "",
    "tokenRoyality" : 0,
    "tokenBid" : true,
    "tokenOwner" : "",
    "tokenCreator" : "",
     "timestamp" : null,  
}

const TokenListView = () => {


    const navigate = useNavigate();


    const [formValue, setFormValue] = useState(initialFormValue);
    const [showingLoader, setshowingLoader] = React.useState(false);
    const [showtryagain, setshowtryagain] = React.useState("false");
    const [owner_Get, set_Owner_Get] = useState('')
    const [noofitemss, setnoofitems] = useState(0);
    const [noofitems, setnoofitemss] = useState(0)
    const [token_price, set_token_price] = useState(0);
    const [token_balance, set_token_balance] = useState(0);
    const [token_owner, set_token_owner] = useState('');
    const [deleted, setdeleted] = useState(0)


    const { Owner, Id } = useParams();

    useEffect(() => {
        getTokenData();
    }, [])
    
    const getTokenData = async () => {
        
        var reqdata = {
            tokenCounts: Id,
            tokenOwner: Owner
        }
        var test = await gettokendata(reqdata);
        
        if (test && (test.cmsData).length > 0) {
            let formdata = {};
            formdata['image'] = test.cmsData[0].image;
            formdata['swapPrice'] = test.cmsData[0].swapPrice;
            formdata['tokenDesc'] = test.cmsData[0].tokenDesc;
            if (test.cmsData[0].tokenOwnerDb && test.cmsData[0].tokenOwnerDb.tokenPrice) {
                formdata['tokenPrice'] = test.cmsData[0].tokenOwnerDb.tokenPrice;
                set_token_price(test.cmsData[0].tokenOwnerDb.tokenPrice)

            }
            else {
                formdata['tokenPrice'] = test.cmsData[0].tokenPrice;
                set_token_price(test.cmsData[0].tokenPrice)
            }
            //    formdata['tokenPrice'] = test.cmsData[0].tokenPrice;
            formdata['likecount'] = test.cmsData[0].likecount;
            formdata['tokenCategory'] = test.cmsData[0].tokenCategory;
            formdata['hashValue'] = test.cmsData[0].hashValue;
            formdata['status'] = test.cmsData[0].status;
            setdeleted(test.cmsData[0].tokenOwnerDb.deleted)
            //    formdata['deleted'] = test.cmsData[0].deleted;
            formdata['tokenQuantity'] = test.cmsData[0].tokenQuantity;
            formdata['balance'] = test.cmsData[0].tokenOwnerDb.balance;
            setnoofitemss(test.cmsData[0].tokenOwnerDb.balance)
            set_token_balance(test.cmsData[0].tokenOwnerDb.balance)
            formdata['contractAddress'] = test.cmsData[0].contractAddress;
            formdata['type'] = test.cmsData[0].type;
            formdata['minimumBid'] = test.cmsData[0].minimumBid;
            formdata['endclocktime'] = test.cmsData[0].endclocktime;
            formdata['clocktime'] = test.cmsData[0].clocktime;
            formdata['unlockcontent'] = test.cmsData[0].unlockcontent;
            formdata['counts'] = test.cmsData[0].counts;
            formdata['PutOnSale'] = test.cmsData[0].PutOnSale;
            formdata['PutOnSaleType'] = test.cmsData[0].PutOnSaleType;
            formdata['ipfsimage'] = test.cmsData[0].ipfsimage;
            formdata['tokenCounts'] = test.cmsData[0].tokenCounts;
            formdata['tokenName'] = test.cmsData[0].tokenName;
            formdata['tokenRoyality'] = test.cmsData[0].tokenRoyality;
            formdata['tokenBid'] = test.cmsData[0].tokenBid;
            formdata['tokenOwner'] = test.cmsData[0].tokenOwnerDb.tokenOwner;
            set_token_owner(test.cmsData[0].tokenOwnerDb.tokenOwner)
            formdata['tokenCreator'] = test.cmsData[0].tokenCreator;
            //    if(test.cmsData[0].tokenOwnerDb&&test.cmsData[0].tokenOwnerDb.timestamp!=""){
            formdata['timestamp'] = test.cmsData[0].tokenOwnerDb.timestamp;
            // set_timestamp(test.cmsData[0].tokenOwnerDb.timestamp)
            // }
            // else{
            //  formdata['timestamp'] = test.cmsData[0].timestamp;
            //  set_timestamp(test.cmsData[0].timestamp)
            // }
            
            setFormValue(formdata)
        }

    }
    
    const Burntoken = async (data) => {
        var ownget = ""
        // var tokenowner = data.tokenowners_current[0].tokenOwner,
        var tokenCounts = data.tokenCounts;
        var tokenConractAdd = data.contractAddress;
        var type = data.type;
        // NOFToken=data.tokenowners_current[0].balance;
        var posdata = {
            tokenCounts: tokenCounts,
            contractAddress: tokenConractAdd,
            type: type,
            balance: noofitemss,
            tokenOwner: token_owner,
            quant: token_balance

        }
        var web31 = new Web3(config.BNBProvider)
        var CoursetroContract = new web31.eth.Contract(EXCHANGE, config.exchangeAddress);
        ownget = await CoursetroContract.methods.owner().call()
        
        ownget = String(ownget).toLowerCase();
        set_Owner_Get(ownget)
        // burn(address from, uint256 tokenCounts, address token, uint256 _type, uint256 NOFToken )
        if (window.ethereum) {
            var web3 = new Web3(window.ethereum);
            if (web3 !== undefined) {
                //   alert('1')
                await window.ethereum.enable()
                    .then(async () => {
                        // alert('2')
                        const web3 = new Web3(window.web3.currentProvider)
                        if (window.web3.currentProvider.isMetaMask === true) {
                            if (((window.web3.eth.defaultAccount).toLowerCase()) != ownget) {
                                toast.error("Can Admin only burn token", 1000)
                            } else {

                                var currAddr = window.web3.eth.defaultAccount;
                                var result = await web3.eth.getAccounts()
                                var setac = result[0]
                                //   alert('3')
                                var addes = String(setac).toLowerCase()
                                if (window.web3.currentProvider.networkVersion == config.networkVersion) {
                                    // alert(token_owner,data.tokenCounts,data.contractAddress,data.type,token_balance)
                                    
                                    var CoursetroContract1 = null
                                    var burnData = null

                                    if (type == 721) {
                                        setshowtryagain('process')

                                        CoursetroContract1 = new web3.eth.Contract(SINGLE, config.singleContract);
                                        //  burnData={tokenCounts}
                                        await CoursetroContract1
                                            .methods
                                            .burn(tokenCounts)
                                            .send({ from: setac })
                                            .then(async (data) => {

                                                var updateBurnField = await BurnField(posdata)
                                                if (updateBurnField) {
                                                    showtryagain('done')
                                                    toast.success('Burned successfully')
                                                    navigate(-1)
                                                }
                                                else {

                                                }

                                            })
                                            .catch((e) => {
                                                setshowtryagain("true")
                                            })
                                    }
                                    else {
                                        setshowtryagain('process')

                                        CoursetroContract1 = new web3.eth.Contract(MULTIPLE, config.multipleContract);
                                        // burnData={};
                                        await CoursetroContract1
                                            .methods
                                            .burn(addes, tokenCounts, noofitemss)
                                            .send({ from: setac })
                                            .then(async (data) => {

                                                var updateBurnField = await BurnField(posdata)
                                                if (updateBurnField) {
                                                    setshowtryagain('done')
                                                    toast.success('Burned successfully', 1000)
                                                    navigate(-1)
                                                }
                                                else {

                                                }

                                            })
                                            .catch((e) => {
                                                setshowtryagain("true")
                                            })
                                    }


                                } else {
                                    toast.warning('please connect binance network', 1000)

                                }
                            }
                        }
                        else {
                            toast.warning('please connect metamsk', 1000)
                        }

                    })
            }
            else {
                toast.warning('please connect metamsk', 1000)
            }

        }
    }

    const onChange = (e) => {
        e.preventDefault();
        const { id, value } = e.target;
        let formData = { ...formValue, ...{ [id]: value } }
        setFormValue(formData)
    }

    const {

        image,
        swapPrice,
        tokenDesc,
        tokenPrice,
        tokenCategory,
        likecount,
        hashValue,
        status,
        // deleted,
        tokenQuantity,
        balance,
        contractAddress,
        type,
        minimumBid,
        endclocktime,
        clocktime,
        tokenProperty,
        unlockcontent,
        counts,
        PutOnSale,
        PutOnSaleType,
        ipfsimage,
        tokenCounts,
        tokenName,
        tokenRoyality,
        tokenBid,
        tokenOwner,
        tokenCreator,
        timestamp,
    } = formValue


    const hideshow = async (deleted) => {
        
        if (deleted == 1) {
            var postdata = {
                deleted: 0,
                tokenCounts: tokenCounts,
                tokenOwner: tokenOwner
            }
            var resp = await deleteStatus(postdata)
            if (resp && resp.userValue) {
                toast.success('Token view status changed', 1000)
                setTimeout(() => {
                    navigate('/TokenList')
                }, (2000));

            }
        }
        else if (deleted == 0) {
            var postdata = {
                deleted: 1,
                tokenCounts: tokenCounts,
                tokenOwner: tokenOwner
            }
            var resp = await deleteStatus(postdata)
            if (resp && resp.userValue) {
                toast.success('Token view status changed', 1000)
                setTimeout(() => {
                    navigate('/TokenList')
                }, (2000));
            }
        }


    }


    return (
        <Layout>
            <div className="tokenlistview">
                <Link to="/TokenList" className="btn sitebtn mb-4">Back</Link>
                <h1 className="pagehead">View NFT</h1>
                <div className="cardbox">
                    <Form>
                        <Row>
                            <Col xs={12} sm={12} md={6} lg={4} className="mb-3">
                                <Form.Group>
                                    <Form.Label>NFT ID</Form.Label>
                                    <Form.Control type="text" value={tokenCounts} disabled={true}/>
                                </Form.Group>
                            </Col>
                            <Col xs={12} sm={12} md={6} lg={4} className="mb-3">
                                <Form.Group>
                                    <Form.Label>NFT Name</Form.Label>
                                    <Form.Control type="text" value={tokenName} disabled={true}/>
                                </Form.Group>
                            </Col>
                            <Col xs={12} sm={12} md={6} lg={4} className="mb-3">
                                <Form.Group>
                                    <Form.Label>NFT Price</Form.Label>
                                    <Form.Control type="text" value={token_price} disabled={true}/>
                                </Form.Group>
                            </Col>
                            <Col xs={12} sm={12} md={6} lg={4} className="mb-3">
                                <Form.Group>
                                    <Form.Label>NFT Royalty (in Percentage)</Form.Label>
                                    <Form.Control type="text" value={tokenRoyality} disabled={true}/>
                                </Form.Group>
                            </Col>
                            <Col xs={12} sm={12} md={6} lg={4} className="mb-3">
                                <Form.Group>
                                    <Form.Label>NFT Total Quantity</Form.Label>
                                    <Form.Control type="text" value={tokenQuantity} disabled={true}/>
                                </Form.Group>
                            </Col>
                            <Col xs={12} sm={12} md={6} lg={4} className="mb-3">
                                <Form.Group>
                                    <Form.Label>NFT Available Quantity(balance)</Form.Label>
                                    <Form.Control type="text" value={token_balance} disabled={true}/>
                                </Form.Group>
                            </Col>
                            <Col xs={12} sm={12} md={6} lg={4} className="mb-3">
                                <Form.Group>
                                    <Form.Label>NFT Category</Form.Label>
                                    <Form.Control type="text" value={tokenCategory} disabled={true}/>
                                </Form.Group>
                            </Col>
                            <Col xs={12} sm={12} md={6} lg={4} className="mb-3">
                                <Form.Group>
                                    <Form.Label>NFT Creator</Form.Label>
                                    <Form.Control type="text" value={tokenCreator} disabled={true}/>
                                </Form.Group>
                            </Col>
                            <Col xs={12} sm={12} md={6} lg={4} className="mb-3">
                                <Form.Group>
                                    <Form.Label>NFT Owner</Form.Label>
                                    <Form.Control type="text" value={token_owner} disabled={true} />
                                </Form.Group>
                            </Col>
                            <Col xs={12} sm={12} md={6} lg={4} className="mb-3">
                                <Form.Group>
                                    <Form.Label>Contract Address</Form.Label>
                                    <Form.Control type="text" value={contractAddress} disabled={true}/>
                                </Form.Group>
                            </Col>
                            <Col xs={12} sm={12} md={6} lg={4} className="mb-3">
                                <Form.Group>
                                    <Form.Label>NFT Type</Form.Label>
                                    <Form.Control type="text" value={type} disabled={true}/>
                                </Form.Group>
                            </Col>
                            <Col xs={12} sm={12} md={6} lg={4} className="mb-3">
                                <Form.Group>
                                    <Form.Label>NFT Hash Value</Form.Label>
                                    <Form.Control type="text" value={hashValue} disabled={true}/>
                                </Form.Group>
                            </Col>
                            <Col xs={12} sm={12} md={6} lg={4} className="mb-3">
                                <Form.Group>
                                    <Form.Label>Created At</Form.Label>
                                    <Form.Control type="text" value={timestamp||''} disabled={true}/>
                                </Form.Group>
                            </Col>
                        </Row>
                        <button type="button" className="btn sitebtn py-2 px-3" onClick={()=>hideshow(deleted)}>
                            {(deleted==1)?'Visible':'Hidden'}
                        </button>
                    </Form>
                </div>
            </div>
        </Layout>
    )
}

export default TokenListView;